import { inject, provideEnvironmentInitializer } from '@angular/core';

import { CosFeatureFlagsToolbarControlsSet } from '@cosmos/feature-flags-toolbar';

export function withListenersDebugger() {
  return provideEnvironmentInitializer(() => {
    const controls = inject(CosFeatureFlagsToolbarControlsSet);
    controls.add(async () => {
      const { CosFeatureFlagsListenersDebuggerComponent } = await import(
        './feature-flags-listeners-debugger.component'
      );
      return CosFeatureFlagsListenersDebuggerComponent;
    });
  });
}
